import { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'beam/dist/styles'
import ChatBubble from './ChatBubble'

const styles = theme => ({
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    height: '100%',
    '@media print': {
      overflow: 'visible',
    },
  },
  bubbleContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: 'relative',
  },
})

/**
 * Represents the complete chat body
 * Separate component to make the print work. Use forwardRef if you decide to change this to a function component.
 */

class ChatBody extends Component {
  render() {
    const { classes, bubbles, queryCurrentIndex, contactTz, contactType } = this.props
    const earliestBubble = bubbles.reduce((m1, m2) => m1.start < m2.start ? m1 : m2, bubbles[0])

    return (
      <div className={classes.root}>
        <div
          className={classes.bubbleContainer}
          data-testid="ChatBody-div-bubbleContainer"
        >
          {bubbles.map((bubble, idx) => {
            return (
              <ChatBubble
                index={idx}
                id={bubble.id}
                start={bubble.start}
                clumps={bubble.clumps}
                authorLabel={bubble.authorLabel}
                isSelectedAgent={bubble.isSelectedAgent}
                callStartTimeMs={earliestBubble.start}
                key={bubble.id + idx}
                queryCurrentIndex={queryCurrentIndex}
                color={bubble.color}
                contactTz={contactTz}
                contactType={contactType}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

ChatBody.propTypes = {
  classes: PropTypes.object.isRequired,
  bubbles: PropTypes.array.isRequired,
  theme: PropTypes.shape({
    spacing: PropTypes.any,
  }),
  queryCurrentIndex: PropTypes.number.isRequired,
  contactTz: PropTypes.string.isRequired,
  contactType: PropTypes.string.isRequired,
}

export default withStyles(styles, { withTheme: true })(ChatBody)
